import {useEffect, useMemo,  useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import { selectSelectedParlayId } from "../../stores/pickX/pickX.selectors";
import {setSelectedParlayId} from "../../stores/pickX/pickX.slice";

const useParlaysAccordionViewModel = ({ userParlays }) => {

    const dispatch = useDispatch();
    const {parlayId} = useParams();
    const selectedParlayId = useSelector(selectSelectedParlayId);
    const [openedParlayId, setOpenedParlayId] = useState(parlayId);

    useEffect(() => {
        if (openedParlayId !== selectedParlayId)
            setOpenedParlayId(selectedParlayId);
    }, [selectedParlayId]);

    const handleParlaySelected = (parlayId) => {
        if(parlayId === openedParlayId){
            setOpenedParlayId(null)
        }else {
            dispatch(setSelectedParlayId(parlayId));
            setOpenedParlayId(parlayId)
        }
    };

    const parlays = useMemo(() => {
        const selectedParlay = userParlays.find(p => p.Id === selectedParlayId);
        const remainingParlays = userParlays.filter(p => p.Id !== selectedParlayId);
        const allParlays = selectedParlay ? [selectedParlay, ...remainingParlays] : userParlays;
        return [...allParlays];
    }, [userParlays, selectedParlayId]);

    const getPlayerNum = (parlayId) => {
        return userParlays.findIndex(p => p.Id === parlayId) + 1;
    };

    return {
        parlays,
        selectedParlayId,
        openedParlayId,
        handleParlaySelected,
        getPlayerNum
    };

}

export default useParlaysAccordionViewModel;